import { v4 as uuid_v4 } from "uuid";
import { http } from "./https.service";

// statistics models
export interface StatisticData {
  regroupement: string;
  evenement: string;
}

export interface StatisticPayload {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

export enum abacaEvent {
  ECRAN_CHANTIER = "CHANTIER",
  SETTINGS = "PARAMETRES",
  EQUIPMENTS = "EQUIPEMENTS",
  BALANCESHEET = "BILAN",
  ADDEQUIPMENT = "AJOUT_EQUIPEMENTS", //This code might be used only in magnolia mail sender.
  SUPPLIERS = "FOURNISSEURS",
}

export function generateUUID(): string {
  const timeStamp = Date.now();
  const id = uuid_v4();
  return `${timeStamp}_${id}`;
}

export function setUserId(): void {
  sessionStorage.setItem("userId", generateUUID());
}

export function getUserId(): string {
  if (!isSetInStorage("userId")) {
    setUserId();
  }
  return sessionStorage.getItem("userId") || "";
}

//methods to store statistics
export function getEventJsonData(event: string, payload?: StatisticPayload): StatisticData {
  const statisticData = Object.assign({
    regroupement: getUserId(),
    evenement: event,
  });

  // if there is a payload attached put it in final json data
  if (payload) {
    statisticData[payload.key] = payload.data;
  }
  return statisticData;
}

export async function sendJsonStatistics(payload: StatisticData): Promise<StatisticData> {
  const { data } = await http.post<StatisticData>("/etools/abaca/statsAnalyse", payload);
  return data;
}

function isSetInStorage(key: string): boolean {
  return sessionStorage.getItem(key) !== null;
}
